import React from "react"

export default function OrderPreferencesForm(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { state, setState } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleInputChange(event) {
    const target = event.target
    const value = target.type === "checkbox" ? target.checked : target.value
    const name = target.name

    setState({
      ...state,
      [name]: value,
    })
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  // -------------------------------------

  return (
    <div className="order-step">
      <h4>{I18n.t("requests")}</h4>
      <fieldset>
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="order_modifications" className="control-label">
                {I18n.t("cart_summary.order_modifications")}
              </label>
              <textarea
                name="order_modifications"
                placeholder={I18n.t(
                  "cart_summary.order_modifications_placeholder"
                )}
                className="form-control"
                value={state.order_modifications}
                onChange={handleInputChange}
              />

              <div className="help-block info">
                {I18n.t("cart_summary.order_modifications_help")}
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <span className="checkbox">
                <label className="control-label">
                  <input
                    type="checkbox"
                    name="baby_sleeping"
                    checked={state.baby_sleeping}
                    onChange={handleInputChange}
                  />
                  {I18n.t("cart_summary.baby_sleeping")}
                </label>
              </span>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  )
}
